import { QueryClient } from '@tanstack/react-query';
import { POLL_PENDING_MARKETS_QUERY_KEY } from '@/lib/offerStatusPolling/usePendingOfferPollingStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 3,
      retryDelay: 3000,
      throwOnError: true,
    },
    mutations: {
      networkMode: 'always',
    },
  },
});

// setup the sever sent events listener store
queryClient.setQueryData(['server-sent-event-listeners'], {
  marketStats: [],
});

// setup the pending offer polling store
queryClient.setQueryData(POLL_PENDING_MARKETS_QUERY_KEY, []);

export default queryClient;
